import React from "react";
import FadeIn from "./FadeIn";
import SectionHeader from "./SectionHeader";

export default function About() {
  const interests = [
    "Systems Engineering",
    "Machine Learning",
    "Rust Ecosystem",
    "Open Source",
    "Toolcraft",
  ];

  return (
    <section id="about" className="w-full py-28 md:py-36 px-6 md:px-12 bg-Base border-t hairline selection:bg-Sapphire selection:text-Base">
      <div className="max-w-4xl w-full mx-auto">
        <SectionHeader number="01" label="Introduction" title="About" />

        <FadeIn>
          <div className="flex flex-col gap-6">
            <p className="text-Text text-lg leading-relaxed font-sans">
              I build systems software that bridges low-level performance with practical engineering outcomes.
              With experience across the full stack — from GPU kernel development and compiler internals to
              distributed systems and web applications — I focus on writing code that is correct, measurable,
              and maintainable.
            </p>

            <p className="text-Subtext0 text-lg leading-relaxed font-sans">
              Most of my work lives in Rust and TypeScript, though I reach for Go, C, or Python depending on the problem.
              I am particularly interested in machine learning infrastructure, real-time graphics, and developer tooling —
              domains where understanding the hardware is just as important as the algorithms running on it.
            </p>

            <div className="w-full border-t hairline my-2"></div>

            <p className="label-caps">
              {interests.join(" · ")}
            </p>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
